module.exports = __webpack_public_path__ + "img/brand-services.03b67af1.svg";